export default "__VITE_ASSET__4bc04b1e__"